export const AccountInformationFieldNames = {
  Bilingual: 'bilingual',
} as const;

export type AccountInformationFields = {
  [AccountInformationFieldNames.Bilingual]?: boolean;
};

export const AccountFields: string[] = Object.values(
  AccountInformationFieldNames,
);
